// src/pages/MyPage/MyUsageHistory.jsx

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MyTokenHistory from "./MyTokenHistory";
import leftArrow from "../../../assets/icons/Arrow/left.svg"
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";


const MyUsageHistory = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const { headerRef, headerSpace } = useFixedLayout();

    // 결제/사용 기록 불러오기
    const fetchPaymentList = useCallback(async () => {
        try {
            const user_id = Number(localStorage.getItem("user_id"));
            if (!user_id) return;

            const res = await axios.get(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ticket/usage/history`,
                {
                    params: { user_id },
                }
            );

            const payload = res.data ?? [];
            const all = Array.isArray(payload)
                ? payload
                : Array.isArray(payload.all)
                    ? payload.all
                    : [];

            setEvents(all);
        } catch (err) {
            console.error("결제/사용 내역 조회 실패", err);
            setEvents([]);
        }
    }, []);

    useEffect(() => {
        fetchPaymentList();
    }, [fetchPaymentList]);

    const navMyPage = () => {
        navigate("/ads/main", { state: { tab: "mypage" } });
    };

    return (
        <div className="bg-white h-dvh">
            {/* 상단 헤더 */}
            <div className="flex items-center justify-start">
                <div
                    className="fixed top-0 left-0 right-0 z-20"
                    ref={headerRef}
                >
                    <HeaderIconL className="headerRef"
                        title="토큰 현황"
                        icon={leftArrow}
                        onIconClick={navMyPage}
                    />
                </div>
            </div>

            <div style={{ paddingTop: headerSpace }}>
                {/* 토큰 사용/충전 기록 UI */}
                <MyTokenHistory events={events} />
            </div>

        </div>
    );
};

export default MyUsageHistory;
